import { PROFILE_IMAGE, EDUCATION, CONTACT } from "@/data";
import { useI18n } from "@/i18n";
import { Reveal, FramedImage } from "./motion";

const Row = ({ left, mid, right, testid }) => (
  <div
    data-testid={testid}
    className="grid grid-cols-1 gap-1 border-b border-[#dcdcd6] py-6 md:grid-cols-12 md:items-baseline md:gap-6"
  >
    <span className="font-body text-[11px] uppercase tracking-[0.16em] text-[#9e8d7b] md:col-span-2">{right}</span>
    <h4 className="font-display text-2xl tracking-tight text-[#1c1c1a] md:col-span-5">{left}</h4>
    <p className="font-body text-sm leading-relaxed text-[#5c5c57] md:col-span-5">{mid}</p>
  </div>
);

export const Profile = () => {
  const { t, lang } = useI18n();
  const p = t.profile;
  return (
    <section id="profil" data-testid="profile-section" className="bg-[#eaeae6] py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-6">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <FramedImage src={PROFILE_IMAGE} alt={CONTACT.name} className="aspect-[4/5] w-full" imgClass="object-[50%_20%]" />
              <div className="mt-6 border-t border-[#dcdcd6] pt-5">
                <div className="font-display text-3xl tracking-tight text-[#1c1c1a]">{CONTACT.name}</div>
                <div className="mt-1 font-body text-[11px] uppercase tracking-[0.2em] text-[#5c5c57]">
                  {p.role}
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pl-10">
            <Reveal>
              <span className="font-body text-[11px] uppercase tracking-[0.28em] text-[#9e8d7b]">{p.label}</span>
              <p className="mt-6 font-display text-3xl leading-[1.15] tracking-tight text-[#1c1c1a] md:text-4xl">
                {p.lead}
              </p>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="mt-14">
                <div className="font-body text-[11px] uppercase tracking-[0.24em] text-[#5c5c57]">{p.experienceTitle}</div>
                <div className="mt-4">
                  {t.experience.map((e, i) => (
                    <Row key={i} testid={`exp-${i}`} left={e.company} mid={`${e.role} — ${e.note}`} right={e.period} />
                  ))}
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-2">
                <div>
                  <div className="font-body text-[11px] uppercase tracking-[0.24em] text-[#5c5c57]">{p.educationTitle}</div>
                  <ul className="mt-4 space-y-4">
                    {EDUCATION.map((ed, i) => (
                      <li key={i} className="border-b border-[#dcdcd6] pb-4">
                        <div className="font-display text-xl text-[#1c1c1a]">{ed[lang].school}</div>
                        <div className="mt-1 font-body text-sm text-[#5c5c57]">{ed[lang].detail}</div>
                        <div className="mt-1 font-body text-[11px] uppercase tracking-[0.16em] text-[#9e8d7b]">{ed[lang].year}</div>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <div className="font-body text-[11px] uppercase tracking-[0.24em] text-[#5c5c57]">{p.languagesTitle}</div>
                  <ul className="mt-4 space-y-4">
                    {t.languages.map((l) => (
                      <li key={l} className="border-b border-[#dcdcd6] pb-4 font-display text-xl text-[#1c1c1a]">{l}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
